var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('em',{staticClass:"fas fa-globe font-18 color-primary-4 mr-2"}),_c('custom-drop-action',{attrs:{"options":_vm.options},on:{"input":_vm.onChangeHandler},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }